import type { ActivityCommentScope } from '@ayocore/activity/common/types/activity-comment-scope';

/**
 * Нормализует произвольный scope-объект (из RPC-payload, pin-payload,
 * chat-item.scope) к каноническому `ActivityCommentScope`.
 *
 * Возвращает null, если `entity_type` или `entity_uuid` пусты после trim,
 * либо если на вход пришёл не-объект (массив, примитив, undefined).
 *
 * Поле `label` опционально: если есть и не пустое — добавляется, иначе пропускается.
 */
export function normalizeActivityScope(scope: unknown): ActivityCommentScope | null {
  if (!scope || typeof scope !== 'object' || Array.isArray(scope)) return null;
  const row = scope as Record<string, unknown>;
  const entityType = typeof row.entity_type === 'string' ? row.entity_type.trim() : '';
  const entityUuid = typeof row.entity_uuid === 'string' ? row.entity_uuid.trim() : '';
  const label = typeof row.label === 'string' ? row.label.trim() : '';
  if (!entityType || !entityUuid) return null;
  return {
    entity_type: entityType,
    entity_uuid: entityUuid,
    ...(label ? { label } : {}),
  };
}
